import templateUrl from "./change-password.html";

export const changePasswordComponent = {
  templateUrl,
  controller: class ChangePasswordComponent {
    constructor($state, AuthService, toastr, ModalService, Constants) {
      "ngInject";

      this.authService = AuthService;
      this.toastr = toastr;
      this.$state = $state;
      this.modalService = ModalService;
      this.Constants = Constants;
    }

    $onInit() {
      this.mismatchPassword = false;
      this.newCurrentPasswordType = "password";
      this.newPasswordType = "password";
      this.showCurrentPassword = false;
      this.showNewPassword = false;
    }

    onCurrentPasswordChange() {
      this.newCurrentPasswordType = this.showCurrentPassword
        ? "text"
        : "password";
    }

    onNewPasswordChange() {
      this.newPasswordType = this.showNewPassword ? "text" : "password";
    }

    onSubmit() {
      if (this.details.newPassword != this.details.reTypePassword) {
        this.mismatchPassword = true;
      } else {
        this.disableButtons = true;
        this.authService
          .updatePassword(this.details)
          .then((details) => {
            this.toastr.success("Password Updated Successfully");
            this.$state.go("home");
          })
          .catch((error) => {
            this.disableButtons = false;
            this.errorMsg = error;
          });
      }
    }

    onCancel() {
      if (this.details === undefined) {
        this.$state.go("home");
      } else {
        this.modalService.open({
          details: {
            bodyMessage: "Changes done will be reverted. Continue?",
          },
          buttons: [
            {
              name: "No",
              action() {},
            },
            {
              name: "Yes",
              isPrimary: true,
              action: _onSubmit.bind(this),
            },
          ],
        });

        function _onSubmit() {
          this.$state.go("home");
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/auth/change-password/change-password.component.js